'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { getDateStringFromState, getStateFromDateString } from '../../utils/datetimeUtils';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DateInput extends Component {
  constructor(props) {
    super(props);
    this.onChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        date: value
      });
      this.props.onChange(getDateStringFromState({
        date: value
      }));
    };
    this.state = getStateFromDateString(this.props.value);
  }
  render() {
    const {
      disabled,
      id,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(UIDateInput, {
      disabled: disabled,
      id: `${id}-date`,
      onChange: this.onChange,
      readOnly: readOnly,
      value: this.state.date
    });
  }
}
DateInput.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.string
};